import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../utils/cn.js';
/**
 * The Clari brand mark — `Clari.`
 *
 * Casing is fixed: capital C, lowercase `lari`, full stop. Never translate,
 * never alter (CLAUDE.md §0). The dot is the brand isotype.
 */
export function BrandMark({ isotypeOnly = false, pulsing = false, size, className, style, }) {
    const mergedStyle = { ...(size !== undefined && { fontSize: size }), ...style };
    if (isotypeOnly) {
        return (_jsx("span", { className: cn('clari-brand', pulsing && 'clari-brand--pulsing', className), "aria-label": "Clari", style: mergedStyle, children: _jsx("span", { className: "clari-brand__dot", "aria-hidden": "true", children: "\u2022" }) }));
    }
    return (_jsxs("span", { className: cn('clari-brand', pulsing && 'clari-brand--pulsing', className), style: mergedStyle, "aria-label": "Clari.", children: [_jsx("span", { "aria-hidden": "true", children: "Clari" }), _jsx("span", { className: "clari-brand__dot", "aria-hidden": "true", children: "." })] }));
}
//# sourceMappingURL=BrandMark.js.map